export const FORM_CONSTANTS = {
	buttonSubmitText: 'Submit',
	buttonSaveText: 'Save',
	buttonCancelText: 'Cancel',
	buttonClearText: 'Clear',
	required: 'Required',
	optional: 'Optional',
	SEARCH: 'Search'
};
